<template>
  <div class="bg-white px-3 index" :style="{height:height}">
    <el-form ref="form" :model="form" label-width="80px" class="form-inlines  ">
      <el-form-item label="答题金额">
        <el-input v-model="form.text" style="width: 300px" placeholder="请输入答题金额" type="number"></el-input>
      </el-form-item>
      <div class="sub_btns">
        <el-form-item>
          <el-button class="btn1" :loading='searchloading' size="small" @click="getmoney" icon="el-icon-refresh-right">
            刷新</el-button>
          <el-button size="small" @click="onSubmit" icon="el-icon-s-promotion" type="primary" :loading='searchloading'>
            提交</el-button>
        </el-form-item>
      </div>
    </el-form>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        form: {
          text: "",
        },
        searchloading: false,
        height: null,
      };
    },
    mounted() {
      this.getmoney()
      this.getHeight()
    },

    methods: {
      getHeight() {
        let that = this
        that.height = window.innerHeight - 180 + 'px'
        window.onresize = () => {
          that.height = window.innerHeight - 180 + 'px'
        }
      },
      getmoney() {
        this.searchloading = true
        let data = {
          id: 294
        }
        this.axios.post('/admin/DictionaryModelTypeContent/ContentEditInfo', data, {
          token: true
        }).then(res => {
          this.form.text = res.data.data.content_value
          this.searchloading = false
        }).catch(err => {
          this.searchloading = false

        })
      },
      onSubmit() {
        if (this.form.text<0) return this.$message('金额不得为负数')
        this.searchloading = true
        let data = {
          "sys_id": 11,
          "type_id": 31,
          "content_name": "答题金额",
          "content_value": this.form.text,
          "id": 294,
          "author": 3,
          "sort": 50
        }
        this.axios.post('/admin/DictionaryModelTypeContent/ContentEdit', data, {
          token: true
        }).then(res => {
          if (res.data.code == 200) {
            this.$message.success('操作成功！')
          } else {
            this.$message.error(res.data.msg)
          }
          this.searchloading = false
        }).catch(err => {
          this.searchloading = false
        })
      },
    },
  };
</script>

<style lang="scss" scoped>
  .sub_btns {
    margin-top: 50px;
    display: flex;

    .btn1 {
      margin-right: 15px;
    }
  }
</style>